const formatDate = date => {
  const months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Setiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];
  const d = new Date(date);
  const day = d.getDate();
  const monthIndex = d.getMonth();

  return `${day} de ${months[monthIndex]}`;
};

export default formatDate;
